/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Dropdown } from '@blend/enterprise-components';
import { getConfig } from 'blb-utils/config';
import { FilterParams, FilterPreset, SettlementAgentFilterParams } from 'blb-constants/pipelineFilter';

export namespace SettlementAgentFilter {
  export interface Props {
    filters: SettlementAgentFilterParams;
    onFilterChanged: (filterParams: FilterParams) => void;
  }
}

const filterOptions: Dropdown.Option[] = [
  { text: 'All closings', value: FilterPreset.ALL_CLOSINGS },
  {
    text: 'Today’s closings with outstanding eSign docs',
    value: FilterPreset.TODAY_CLOSINGS_WITH_OUTSTANDING_ESIGN_DOCS,
  },
  { text: 'Immediate Closings with Documents', value: FilterPreset.IMMEDIATE_CLOSINGS_WITH_DOCS },
  {
    text: 'Today’s and earlier closings with open tasks',
    value: FilterPreset.TODAY_AND_EARLIER_CLOSINGS_WITH_OPEN_TASKS,
  },
];

export const SettlementAgentFilter: React.FC<SettlementAgentFilter.Props> = ({ filters, onFilterChanged }) => {
  if (!getConfig().isSettlementAgentFiltersEnabled) {
    return <></>;
  }
  return (
    <Dropdown
      id="it-preset-filter"
      onChange={e => {
        onFilterChanged({ filterPreset: e.target.value as FilterPreset });
      }}
      options={filterOptions}
      value={filters?.filterPreset || FilterPreset.ALL_CLOSINGS}
      valueRequired={true}
    />
  );
};
